import React, { useEffect, useState } from 'react';
import { Modal, Row, Col, Switch, Button, Divider, Tooltip } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';
import { NumberConsumer } from 'contexts/legacy/NumberContext';
import { api } from 'services/api';
import { InfoCircleOutlined } from '@ant-design/icons';

function MarketingCampaignModal({
	number,
	numberInfo,
	totalCampaigns,
	visible,
	setVisible,
	handleCancelCampaign,
}) {
	const [campaignScheduleTypeId, setCampaignScheduleTypeId] = useState(null);
	const [bitrixWorktime, setBitrixWorktime] = useState(false);
	const [loading, setLoading] = useState(false);
	const scheduleTypeIds = { anyTime: 1, paused: 2, bitrixWorktime: 3, custom: 4 };
	const intl = useIntl();

	useEffect(() => {
		setCampaignScheduleTypeId(numberInfo.campaign_schedule_type_id);
		setBitrixWorktime(numberInfo.campaign_schedule_type_id === 3);
	}, [numberInfo]);

	function getBitrx24WorktimeLink() {
		const domain = number.infos.domain;
		const id_channel = numberInfo.id_channel;
		return `https://${domain}/contact_center/lines_edit/?ID=${id_channel}&IFRAME=Y&PAGE=work-time`;
	}

	function getUpdatedScheduleType() {
		if (bitrixWorktime === (campaignScheduleTypeId === 3)) return null;
		if (bitrixWorktime) return scheduleTypeIds.bitrixWorktime;
		return scheduleTypeIds.anyTime;
	}
	const confirmationMessages = {
		noLinkedChannel: intl.formatMessage({ id: 'confirm_notification_noLinkedChannel' }),
		worktimeDisabled: intl.formatMessage({ id: 'confirm_notification_worktimeDisabled' }),
	};

	async function handleOk() {
		setLoading(true);
		const data = {
			auth: number.infos.auth,
			domain: number.infos.domain,
			channel_id: numberInfo.id,
			bitrix_channel_id: numberInfo.id_channel,
			schedule_type_id: getUpdatedScheduleType(),
		};

		const enabledWorktime = await api.post('/getBitrixWorktimeZone', data);
		let confirmationMessage = '';
		if (bitrixWorktime && numberInfo.id_channel == null) {
			confirmationMessage = confirmationMessages.noLinkedChannel;
		} else if (bitrixWorktime && enabledWorktime.data == 'N') {
			confirmationMessage = confirmationMessages.worktimeDisabled;
		}

		if (
			(bitrixWorktime && numberInfo.id_channel == null) ||
			(bitrixWorktime && enabledWorktime.data == 'N')
		) {
			Modal.confirm({
				content: confirmationMessage,
				cancelText: intl.formatMessage({ id: 'cancel' }),
				onOk: async () => {
					if (data.schedule_type_id) {
						await api.post('/updateNumberScheduleType', data);
						numberInfo.campaign_schedule_type_id = data.schedule_type_id;
					}
					setVisible(false);
				},
				onCancel: () => {
					setLoading(false);
				},
				icon: null,
			});
			return;
		}

		if (data.schedule_type_id) {
			await api.post('/updateNumberScheduleType', data);
			numberInfo.campaign_schedule_type_id = data.schedule_type_id;
		}

		setVisible(false);
	}

	return (
		<Modal
			okButtonProps={{ loading }}
			title="Configurações"
			visible={visible}
			width={420}
			onCancel={() => setVisible(false)}
			onOk={handleOk}
			cancelText={<FormattedMessage id="cancel" />}
		>
			<Row type="flex" align="middle">
				<Col>
					<FormattedMessage id="send_only_during_work_hours" />
				</Col>
				<Col style={{ display: 'flex', justifyContent: 'start' }}>
					<Tooltip
						title={
							<div>
								<p>
									<FormattedMessage id="work_hours_defined_in_bitrix24_channel" />
								</p>
								<a href={getBitrx24WorktimeLink()} target="_blank" rel="noopener noreferrer">
									<FormattedMessage id="click_here_to_configure" />
								</a>
							</div>
						}
					>
						<InfoCircleOutlined className="ml-1" style={{ fontSize: 16, color: '#238bed' }} />
					</Tooltip>
				</Col>
				<Col className="ml-auto">
					<Switch checked={bitrixWorktime} onChange={setBitrixWorktime} />
				</Col>
			</Row>
			<Divider />
			<Row>
				<Col span={18}>
					<p>
						<FormattedMessage id="clear_queue_immediately" />
					</p>
				</Col>
				<Col span={6} style={{ display: 'flex', justifyContent: 'end' }}>
					<Button
						onClick={() => {
							handleCancelCampaign();
							setTimeout(() => setVisible(false), 200);
						}}
						disabled={!(totalCampaigns > 0)}
						type="primary"
					>
						<FormattedMessage id="cancel_campaign" />
					</Button>
				</Col>
			</Row>
		</Modal>
	);
}

export default NumberConsumer(MarketingCampaignModal);
